<template>
    <!-- Inspector create modal -->
    <div class="modal fade" id="modal-create-inspector" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-popin">
            <div class="modal-content">
                <div :class="[working ? 'block-opt-refresh' : '', 'block', 'block-themed', 'block-transparent']">
                    <div class="block-header bg-primary-dark">
                        <ul class="block-options">
                            <li>
                                <button data-dismiss="modal" type="button"><i class="icon-close"></i></button>
                            </li>
                        </ul>
                        <h3 class="block-title">Create Forester</h3>
                    </div>
                    <div class="block-content">
                        <p class="alert alert-info">Fill out the following form in order to add a new forester.  Foresters are able to create new inspections and submit them for approval.  New foresters will receive and email with login information, including a randomly generated password.</p>

                        <div class="form-horizontal push-10-t">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.first_name.$error }">
                                        <label class="col-xs-12" for="first_name">First Name</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.first_name" v-on:blur="$v.inspector.user.contact.first_name.$touch">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-xs-12" for="first_name">Middle Name</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.middle_name">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.last_name.$error }">
                                        <label class="col-xs-12" for="last_name">Last Name</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.last_name" v-on:blur="$v.inspector.user.contact.last_name.$touch">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.inspector_license.$error }">
                                        <label class="col-xs-12" for="last_name">ID#</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.inspector_license" v-on:blur="$v.inspector.inspector_license.$touch">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.email.$error }">
                                        <label class="col-xs-12" for="email">Email Address</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="email" v-model="inspector.user.email" v-on:blur="$v.inspector.user.email.$touch">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-xs-12" for="phone">Phone <small class="text-muted">(optional)</small></label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="wcphone" v-model="inspector.user.contact.phone">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-xs-12" for="company">Company <small class="text-muted">(optional)</small></label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.company">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.address.$error }">
                                        <label class="col-xs-12" for="address">Street Address</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.address" v-on:blur="$v.inspector.user.contact.address.$touch">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.locality.$error }">
                                        <label class="col-xs-12" for="city">City</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.locality" v-on:blur="$v.inspector.user.contact.locality.$touch">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.region_id.$error }">
                                        <label class="col-xs-12" for="province">State</label>
                                        <div class="col-xs-12">
                                            <select class="form-control valid" v-model="inspector.user.contact.region_id" v-on:blur="$v.inspector.user.contact.region_id.$touch">
                                                <option v-for="region in regions" :value="region.id">{{ region.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group" v-bind:class="{ 'has-error': $v.inspector.user.contact.postal_code.$error }">
                                        <label class="col-xs-12" for="postal_code">Zip Code</label>
                                        <div class="col-xs-12">
                                            <input class="form-control" type="text" v-model="inspector.user.contact.postal_code" v-on:blur="$v.inspector.user.contact.postal_code.$touch">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="form-group">
                                <div class="col-xs-12">
                                    <button class="btn btn-lg btn-block btn-primary" v-on:click="create">
                                        Create Forester
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Landowner create modal -->
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';

    export default {
        data () {
            return {
                //user: Object.assign({password: 'password'}, this.$schema.map('user')), // FIXME
                inspector: this.$schema.map('inspector'),
                regions: [],
                working: false
            };
        },
        methods: {
            create () {
                // Trigger validation
                this.$v.$touch();

                // Halt submission if credentials are invalid
                if (this.$v.$invalid) {
                    this.$toasted.error('Please complete all required fields.');
                    return;
                }

                this.working = true;

                // Create inspector
                this.axios.post('inspectors', this.inspector)
                    .then((response) => {
                        this.working = false;

                        // Reset inspector data
                        _.each(this.inspector, (item) => { item = ''; });

                        // Fire create success event
                        this.$emit('created', response.data);

                        // Notify user and close the modal
                        if(response.data.meta && response.data.meta.error) {
                            this.$swal({
                                title: `Error encountered!`,
                                text: response.data.meta.error,
                                type: "error",
                                confirmButtonText: 'OK',
                            });
                        }
                        else {
                            this.$toasted.success('Forester created!');
                        }
                        jQuery('#modal-create-inspector').modal('toggle');
                    });
            }
        },
        created () {
            // Get regions
            this.axios.get('regions').then((response) => {
                this.regions = response.data.data;
            });
        },
        validations: {
            inspector: {
                inspector_license: { required },
                user: {
                    email: { required, email },
                    contact: {
                        first_name: { required },
                        last_name: { required },
                        address: { required },
                        locality: { required },
                        region_id: { required },
                        postal_code: { required }
                    }
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// inspector-create-modal.vue?016e75e0